<div class="container">
    <nav aria-label="breadcrumb" class="breadCust">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription</a></li>
        <li class="breadcrumb-item active" aria-current="page">Subscription Limit</li>
      </ol>
    </nav>
  </div>
  
  <div class="container mt-1 themeTblReso">
    <div class="assignFilterBar">
      <div class="filterItem" *ngIf="companyID==0">
        <select name="company" class="form-control formstyle" [ngModel]="selectedCompany" (ngModelChange)="onCompanyChange($event)">
          <option value="">Select Company Name</option>
          <ng-container *ngFor="let userObj of getCompanyobj">
            <option *ngIf="userObj.dbstatus == true" value={{userObj.customer_id}}>
              {{ userObj.customer_company_name }}
            </option>
          </ng-container>
        </select>
      </div>
      <div class="filterItem filterSearch">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text cyan lighten-2" id="basic-text1"><i class="fa fa-search text-white"
                aria-hidden="true"></i></span>
          </div>
          <input class="form-control" type="text" placeholder="Search" aria-label="Search" #searchText/>
        </div>
      </div>
      <div class="filterAction">
        <input type="button" value="Reset" class="custbtn-outline" (click)="resetFilters()" />
        <input type="button" value="Add New" class="custbtn" routerLink="/corporate/addSubscriptionLimit" />
      </div>
    </div>
    <div class="tblPrt">
      <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <th (click)="setOrder('title')" style="cursor: pointer">Subscription Title <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
          <th>Component Name</th>
          <th>Component Limit</th>
          <th>Time Limit</th>
          <th (click)="setOrder('createdon')" style="cursor: pointer">
            Created On <i class="fa fa-sort text-black" aria-hidden="true"></i>
          </th>
          <th>Actions</th>
        </tr>
        <tr *ngFor="let limit of limitObj">
          <td>{{limit?.title}}</td>
          <td>{{limit?.component_name}}</td>
          <td>{{ limit?.component_limit }}</td>
          <td>{{ limit?.time_limit }}</td>
          <td>{{limit?.createdon | date: "mediumDate"}}</td>
          <td>
            <div class="actBtn">
              <i *ngIf='isEdit' class="fa fa-edit mr-1 linkForce" (click)="editPost(limit.id)"></i>
              <i *ngIf='isEdit' class="fa fa-trash mr-1 linkForce"
                (click)="delLimit($event, limit.id)"></i>
              <mat-slide-toggle *ngIf='isEdit' class="my-slider" [checked]="limit.isactive"
                (click)="updateStatus($event, limit.id, limit.isactive)">
              </mat-slide-toggle>
            
            </div>
          </td>
        </tr>
      </table>
      <div *ngIf="limitTotal == 0" style="text-align: center">
        <p>No Result Available</p>
      </div>
      <div class="mt-2 text-center difPagination" *ngIf="limitTotal > 10">
        <ngb-pagination [collectionSize]="limitTotal" [(page)]="slCatPage" [maxSize]="2" [rotate]="true" (pageChange)="getlimit(slCatPage=$event)" aria-label="Custom pagination">
          <ng-template ngbPaginationPrevious>Prev</ng-template>
          <ng-template ngbPaginationNext>Next</ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
  